import { useTranslate } from "../../hooks/useTranslate";
import { ControlCheckbox as Checkbox } from "../Checkbox";

import { Wrapper } from "./styles";

interface Props {
  cb: (id: string) => void;
  id: string;
  name: string;
  count: number;
  checked: boolean;
}

const CardOfFlocksOrBatchsForManagement = ({
  cb,
  checked,
  id,
  name,
  count,
}: Props) => {
  const { translate } = useTranslate();

  return (
    <Wrapper
      onClick={() => {
        cb(id);
      }}
    >
      <p>
        {name} -{" "}
        <span>
          {count}{" "}
          {count === 1
            ? translate("animals.animal_singular")
            : translate("animals.animal_plural")}
        </span>
      </p>
      <Checkbox checked={checked} />
    </Wrapper>
  );
};

export { CardOfFlocksOrBatchsForManagement };
